import React from "react";

const TwitterSVG = ({ width = 12, height = 13.5 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15.8 16.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49752 6.9558L15.3395 0.224609H13.9749L8.87296 6.06562L4.77554 0.224609H3.41096H1.36425H1.14431H0L6.19736 9.12907L0 16.2246H1.45243L6.82658 10.0327L11.136 16.2246H11.3782H12.5887H14.5476H15.0098H16L9.49752 6.9558ZM2.1259 1.31009H4.16662L8.096 6.95547L6.9813 8.23167L2.1259 1.31009ZM11.8271 15.1395L7.61085 9.1294L8.71956 7.85189L13.7916 15.1395H11.8271Z"
        fill="black"
      />
    </svg>
  );
};

export default TwitterSVG;
